import { Pagination } from "react-bootstrap";
import { CrudTablePaginationModel } from "./crudTablePaginationModel";

export const CrudTablePagination = ({
  current,
  count,
  getCanPreviousPage,
  firstPage,
  previousPage,
  setPageIndex,
  getCanNextPage,
  nextPage,
  lastPage,
}: CrudTablePaginationModel) => {
  return (
    <Pagination className={"ms-auto res-pagination"}>
      <Pagination.First
        disabled={!getCanPreviousPage()}
        onClick={() => firstPage()}
      />
      <Pagination.Prev
        disabled={!getCanPreviousPage()}
        onClick={() => previousPage()}
      />

      {count > 5 ? (
        <>
          <Pagination.Item
            key={0}
            onClick={() => setPageIndex(0)}
            active={current == 0}
          >
            {1}
          </Pagination.Item>
          {current > 1 && <Pagination.Ellipsis disabled key="ellipsis-1" />}
          {[...Array(3)].map((_, i) => {
            let index = current - 1 + i;

            if (current < 1) {
              index = index + 2;
            } else if (current < 2) {
              index = index + 1;
            } else if (current === count - 1) {
              index = index - 2;
            } else if (current > count - 3) {
              index = index - 1;
            }

            return (
              <Pagination.Item
                key={index}
                onClick={() => setPageIndex(index)}
                active={current == index}
              >
                {index + 1}
              </Pagination.Item>
            );
          })}
          {current < count - 2 && (
            <Pagination.Ellipsis disabled key="ellipsis-2" />
          )}
          <Pagination.Item
            key={count - 1}
            onClick={() => setPageIndex(count - 1)}
            active={current == count - 1}
          >
            {count}
          </Pagination.Item>
        </>
      ) : (
        <>
          {[...Array(count)].map((_, i) => (
            <Pagination.Item
              key={i}
              onClick={() => setPageIndex(i)}
              active={current == i}
            >
              {i + 1}
            </Pagination.Item>
          ))}
        </>
      )}

      <Pagination.Next
        disabled={!getCanNextPage()}
        onClick={() => nextPage()}
      />
      <Pagination.Last
        disabled={!getCanNextPage()}
        onClick={() => lastPage()}
      />
    </Pagination>
  );
};
